<template>
  <v-app class="app">
    <v-main>
      <router-view/>

      <!-- Global Snackbar -->
      <v-snackbar v-model="snackbar" :timeout="2500" :color="snackColor" location="top" transition="slide-y-transition">
        <v-row dense>
          <v-col cols="1">
            <v-icon>mdi-alert-circle</v-icon>
          </v-col>
          <v-col cols="11">
            <span style="white-space: pre-line;">{{ snackText }}</span>
          </v-col>
        </v-row>
      </v-snackbar>

    </v-main>
  </v-app>
</template>

<script>
import { useSnackbar } from './composables/useSnackbar'
import pdfMake from "pdfmake/build/pdfmake";
import { vfs } from "@/assets/vfs_fonts";
pdfMake.vfs = vfs;
pdfMake.fonts = {
  ArialNarrow: {
    normal: "arialnarrow.ttf",
    bold: "arialnarrow_bold.ttf",
    italics: "arialnarrow_italic.ttf",
    bolditalics: "arialnarrow_bolditalic.ttf"
  },
  TimesNewRoman: {
    normal: "times-new-roman-bold-italic.ttf",
    bold: "times-new-roman-bold-italic.ttf",
    italics: "times-new-roman-bold-italic.ttf",
    bolditalics: "times-new-roman-bold-italic.ttf"
  },
  CenturySchoolBook: {
    normal: "century-schoolbook-bolditalics.ttf",
    bold: "century-schoolbook-bolditalics.ttf",
    italics: "century-schoolbook-bolditalics.ttf",
    bolditalics: "century-schoolbook-bolditalics.ttf"
  }
};

export default {
  name: 'App',
  setup() {
    const { snackbar, snackText, snackColor } = useSnackbar()
    return { snackbar, snackText, snackColor }
  },
  data: () => ({
    //
  }),
}
</script>

<style>
body{
   background-color: '#5B7459';
}

html { 
  overflow-y: auto !important 
}

.dt-container {
    border-radius: 10px !important;
}
.dt-container thead th {
    background-color: #1a5b0f;
    color: white !important;
}
.dt-container thead th:first-child {
    border-radius: 10px 0 0 0;
}

.dt-container thead th:last-child {
    border-radius: 0 10px 0 0;
}

.v-data-table-headers--mobile {
  display: none;
}

.custom-snackbar {
  position: fixed !important; /* Use fixed instead of absolute */
  top: 50%;
  left: 50%;
  transform: translate(-10%, -51%);
}

/* ::-webkit-scrollbar {
  width: 8px;
} */

/* Track */
/* ::-webkit-scrollbar-track {
  background: '#F5F5F5';
}  */

/* Handle */
/* ::-webkit-scrollbar-thumb {
  background: '#F5F5F5';
  border-radius: 10px;
} */

/* Handle on hover */
/* ::-webkit-scrollbar-thumb:hover {
  background: '#F5F5F5';
} */

@keyframes fadeIn {
    0%{
       opacity: 0;
       transform: translateZ(0);
    }
    100%{
       opacity: 1;
       transform: translateZ(100%)
    }
}

@keyframes viewUp {
    0%{
       opacity: 0;
       transform: translateY(0);
    }
    50%{
       opacity: 0.5;
       transform: translateY(12px)
    }
    100%{
       opacity: 1;
       transform: translateY(0)
    }
}

.doughnut-style {
    width:110px;
    height:110px;
    margin: 7px;
}

.toggle{
    -webkit-animation-name: fadeIn;
    animation-name: fadeIn;
}

.animated{
  -webkit-animation-duration: 0.8s;
  animation-duration: 0.8s;
}
</style>